import { render } from "./MapasAprendizaje.vue?vue&type=template&id=23f8cd72"
import script from "./MapasAprendizaje.vue?vue&type=script&lang=js"
export * from "./MapasAprendizaje.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__